import { useGlobalClientContext } from '../common/GlobalClientContext';

export default function TermsV2() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  const privacyHref = `/privacy`;
  const termsHref = `/site-terms`;
  const policyHref = `/policy`;

  const hreflinkClasses = [
    'group',
    'flex',
    'items-center',
    'gap-1',
    'font-button',
    'text-sm',
    'leading-lg',
    'text-gray-700',
    'cursor-pointer',
    'hover:text-primary',
    'hover:no-underline',
    'active:text-primary'
  ].join(' ');

  return (
    <div className="flex flex-row items-center justify-center gap-[28px] text-[#05A8FD]!">
      {
        <a
          href={termsHref}
          target="_blank"
          className={`${hreflinkClasses} font-medium`}>
          {t('terms.capitalize', {})}
        </a>
      }
      {
        <a
          href={privacyHref}
          target="_blank"
          className={`${hreflinkClasses} font-semibold`}>
          {t('privacy.capitalize', {})}
        </a>
      }
      {
        <a
          href={policyHref}
          target="_blank"
          className={`${hreflinkClasses} font-medium`}>
          {t('policy.notice.title', {})}
        </a>
      }
    </div>
  );
}
